import React, { useEffect } from 'react';
import SchoolProfileStateLayout from './SchoolProfileStateLayout';
import { resetDocumentMetadata, setDocumentMetadata } from '../../utils/documentMeta';

const TITLE = 'We could not load this school profile';
const MESSAGE =
  'The page did not load. Check your connection and try again — the school profile itself is fine.';

/** Request-failure state with a retry action. Raw API errors are never shown. */
const SchoolProfileError = ({ onRetry }) => {
  useEffect(() => {
    setDocumentMetadata({
      title: 'School profile | AtadaBoard',
      description: MESSAGE,
      robots: 'noindex, follow',
    });
    return resetDocumentMetadata;
  }, []);

  return (
    <SchoolProfileStateLayout code="Connection failed" title={TITLE} message={MESSAGE}>
      <button type="button" className="sp-btn sp-btn-primary" onClick={onRetry}>
        Try Again
      </button>
      <a className="sp-link-action" href="/">
        Go to AtadaBoard
      </a>
    </SchoolProfileStateLayout>
  );
};

export default SchoolProfileError;
